<template>
  <div class="appHeader">
    <div class="windowControls">
      <div class="leftAction"></div>
      <div class="rightAction" v-if="showRight">
        <svg-icon
          iconClass="pin"
          :className="{
            pin: isPin,
          }"
          @onClick="pinMain"
          v-baidu-event-tracking="{ feature: '主窗口', action: isPin ? '取消置顶' : '置顶' }"
        ></svg-icon>
        <el-tooltip placement="bottom-end" popper-class="morePop">
          <div slot="content" class="morePopover">
            <div class="head" @click="openUrl($t('appHeader.more.title.href'))">
              <div class="title">{{ $t('appHeader.more.title.text') }}</div>
              <div class="desc">{{ $t('appHeader.more.desc') }}</div>
            </div>
            <div class="box">
              <ul>
                <li @click="openUrl($t('appHeader.more.box.online.href'))">
                  {{ $t('appHeader.more.box.online.text') }}
                </li>

                <li @click="openUrl($t('appHeader.more.box.question.href'))">
                  {{ $t('appHeader.more.box.question.text') }}
                </li>
                <li @click="openUrl($t('appHeader.more.box.dynamic.href'))">
                  {{ $t('appHeader.more.box.dynamic.text') }}
                </li>
                <li @click="clickHotKey">
                  {{ $t('appHeader.more.box.short.text') }}
                </li>
                <li @click="clickReferral">{{ $t('pages.Referral.title') }}</li>

                <li @click="openUrl('https://help.flomoapp.com/basic/app.html#iphone-ipad')">
                  {{ $t('appHeader.more.box.download') }}
                </li>
              </ul>
            </div>
            <div class="foot">
              <div class="checkUpdate" @click="checkUpdate" v-if="!downloaded && !isMas">
                {{ $t('web_app.tips.checkUpdate') }}
              </div>
              <div class="update" @click="relanchApp" v-if="downloaded && !isMas">
                <div>{{ $t('web_app.tips.update') }}</div>
                <div>{{ $t('web_app.tips.updateAction') }}</div>
              </div>

              <div class="desc">{{ $t('web_app.tips.version') }} {{ appVersion }}</div>
            </div>
          </div>
          <svg-icon :iconClass="'more'" className="icon" id="more"></svg-icon>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import cfg from '../../../config'
export default {
  name: 'appHeader',
  data() {
    return {
      user: this.$store.state.me,
      canGoBack: false,
      canGoForward: false,
      appVersion: cfg.VUE_APP_VERSION,
      isPin: false,
      isMas: false,
    }
  },
  props: {
    showRight: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    clickDownloadDot() {
      return this.$store.state.clickDownloadDot
    },
    downloaded() {
      return this.$store.getters['appUpdate/downloaded']
    },
  },
  methods: {
    async checkUpdate() {
      this.$store.dispatch('appUpdate/setShowUpdateModal', true)
    },
    relanchApp() {
      window.ipcRenderer.send('installNow')
    },

    pinMain() {
      this.isPin = !this.isPin
      window.ipcRenderer.send('pinMain', this.isPin)
      //this.$message({
      //  message: this.isPin ? this.$t('appHeader.pinMain') : this.$t('appHeader.unpinMain'),
      //  type: 'success',
      //  duration: 800,
      //})
    },

    openUrl(url) {
      if (!url) {
        return
      }
      if (this.$isElectron) {
        window.ipcRenderer.send('openUrl', url)
      } else {
        window.open(url, '_blank')
      }
    },
    clickReferral() {
      this.$store.commit('setSelectedSource', 'referral')
      this.$emit('tag-clicked')
    },
    clickHotKey() {
      this.$store.commit('setSelectedSource', 'hotkey')
      this.$emit('tag-clicked')
    },
  },
  created() {
    this.isMas = window.isMAS != undefined && window.isMAS
  },
}
</script>
<style lang="scss" scoped>
.appHeader {
  height: 40px;
  -webkit-app-region: drag;
  .windowControls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .icon {
      padding: 6px;
      margin: 6px 10px;
      cursor: pointer;
      border-radius: 6px;
      user-select: none;
      &:hover {
        background-color: var(--grayLight);
      }
    }
    .disabled {
      opacity: 0.5;
      cursor: default;
    }
    .leftAction {
      margin-left: 170px;
      -webkit-app-region: no-drag;
    }
    .rightAction {
      -webkit-app-region: no-drag;
      display: flex;
      align-items: center;
      svg {
        margin: 0px 5px;
        padding: 3px;
        border-radius: 6px;
        cursor: pointer;
        &:hover {
          background-color: var(--hoverBg);
        }
        &:last-child {
          margin-right: 10px;
        }
      }

      .pin {
        color: var(--bgGreen);
      }
    }
  }
}
</style>
<style lang="scss">
.morePop {
  padding: 0px !important;
  border: none !important;
  background: var(--glassBg) !important;
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
}
.morePopover {
  width: 200px;
  box-sizing: border-box;
  border-radius: 6px;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  .head {
    border-bottom: 1px solid var(--divider);
    padding: 15px 15px;
    cursor: pointer;

    .title {
      font-weight: 500;
      font-size: 14px;
      color: var(--popupColor);
      &:hover {
        color: #55bb8e;
      }
    }
    .desc {
      font-size: 12px;
      color: var(--descColor);
    }
  }
  .box {
    ul {
      li {
        list-style: none;
        padding: 7px 15px;
        font-size: 14px;
        color: var(--popupColor);
        cursor: pointer;
        &:first-child {
          padding-top: 15px;
        }
        &:last-child {
          padding-bottom: 15px;
        }
        &:hover {
          color: #55bb8e;
        }
      }
      .download {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .dot {
          width: 4px;
          height: 4px;
          background: #be674c;
          border-radius: 3px;
        }
      }
    }
  }
  .foot {
    padding: 15px;
    font-size: 12px;
    border-top: 1px solid var(--divider);
    color: var(--popupColor);
    .checkUpdate {
      font-size: 14px;
      padding-bottom: 15px;
      cursor: pointer;
      &:hover {
        color: #55bb8e;
      }
    }
    .update {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;

      color: var(--popupColor);
      cursor: pointer;
      div {
        &:first-child {
          font-size: 14px;
        }
        &:last-child {
          font-size: 12px;
          color: #e47571;
        }
      }
    }
  }
}

body.dark_mode .morePop {
  backdrop-filter: blur(10px) saturate(190%) contrast(70%) brightness(80%);
}
</style>
